var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconamoonSearchLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6254 37.625L29.8442 29.8438M29.8442 29.8438C31.1752 28.5128 32.231 26.9327 32.9513 25.1936C33.6717 23.4546 34.0424 21.5907 34.0424 19.7083C34.0424 17.826 33.6717 15.9621 32.9513 14.2231C32.231 12.484 31.1752 10.9039 29.8442 9.57288C28.5132 8.24187 26.933 7.18606 25.194 6.46572C23.4549 5.74539 21.591 5.37463 19.7087 5.37463C17.8264 5.37463 15.9625 5.74539 14.2234 6.46572C12.4844 7.18606 10.9043 8.24187 9.57324 9.57288C6.88515 12.261 5.375 15.9068 5.375 19.7083C5.375 23.5099 6.88515 27.1557 9.57324 29.8438C12.2613 32.5319 15.9072 34.042 19.7087 34.042C23.5102 34.042 27.1561 32.5319 29.8442 29.8438Z",
    stroke: "#989797",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconamoonSearchLight);
export default __webpack_public_path__ + "static/media/iconamoon_search-light.013771f4d0f3b187201e73eb2aa0162c.svg";
export { ForwardRef as ReactComponent };